<template>
  <div>
    AAA
  </div>
</template>

<script>
export default {
  name: "scan"
}
</script>

<style scoped></style>